module.exports = __webpack_public_path__ + "static/media/Sao Tome and Principe.86212c6c.png";